import { createContext, ReactNode, useContext } from "react";

import { useFilterUtilAgeBracket } from "./filter-util-age-bracket.hook";

const FilterUtilAgeBracketContext = createContext(
  {} as ReturnType<typeof useFilterUtilAgeBracket>
);
export function useFilterUtilAgeBracketContext() {
  return useContext(FilterUtilAgeBracketContext);
}

interface FilterUtilAgeBracketProviderProps {
  children: ReactNode;
}
export function FilterUtilAgeBracketProvider({
  children,
}: FilterUtilAgeBracketProviderProps) {
  return (
    <FilterUtilAgeBracketContext.Provider value={useFilterUtilAgeBracket()}>
      {children}
    </FilterUtilAgeBracketContext.Provider>
  );
}